<template>
  <div>
    <div class="vendor-form">
      <p class="vendor-form-label">
        {{ label }}<span class="text-ast" v-if="isRequired">*</span>
      </p>
      <div class="vendor-input">
        <p style="color: red">{{ convertFromSkalaBesar(tingkatResiko) }}</p>
        <p>
          Catatan: Isi pertanyaan dengan tingkat resiko Tinggi, Menengah Tinggi,
          Menengah Rendah, Rendah
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'modelName',
    'label',
    'storeName',
    'mutationName',
    'isRequired',
    'disabled',
  ],
  computed: {
    tingkatResiko() {
      return this.$tingkatResikoValue()
    },
  },
}
</script>
